<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <data-grid
        ref="grid"
        stripe
        :pageSizeManual="pageSizeManual"
        v-has-permission="permission129"
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('DraftOrderId'), sort: 'DraftOrderId' },
          { title: $t('SiteOrderNumber'), sort: 'SiteOrderNumber' },
          { title: $t('SalePersonName') },
          { title: $t('PartyName'), sort: 'PartyName' },
          { title: $t('ContractName'), sort: 'ContractName' },
          { title: $t('CreateOn'), sort: 'CreateOn' },
          { title: $t('Description') },
          { title: $t('Action') },
        ]"
      >
        <template slot-scope="{ row, pagination }">
          <td style="width: 12%">{{ row.draftOrderId }}</td>
          <td style="width: 12%">
            {{ "APO-" + row.basketId }}
          </td>
          <td style="width: 16%">
            {{ row.salePersonInfo.name }}
          </td>
          <td style="width: 19%">
            {{ row.dischargePermissionPartyInfoQuery.partyName }}
          </td>
          <td style="width: 11%">
            {{
              row.dischargePermissionContractInfoQuery
                ? row.dischargePermissionContractInfoQuery.contractTitle
                : "---"
            }}
          </td>
          <td style="width: 7%; direction: ltr">
            {{ row.persianCreateOn }}
          </td>
          <td style="width: 15%">
            {{ row.description ? row.description : "---" }} <br />
            {{ row.considerations ? row.considerations : "---" }}
          </td>
          <td style="width: 5%">
            <router-link
              :to="{
                path:
                  '/DischargePermissions/Details/' + tabIndex + '/' + row.id,
                query: {
                  numberRowsPerPage: pagination.pageSize,
                },
              }"
            >
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-eye"
                class="d-inline"
              ></vs-button>
            </router-link>
          </td>
        </template>
      </data-grid>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "warehouseManagement_DischargePermission_WaitingForCheckoutSubmission",

  components: {
    DataGrid,
  },
  props: {
    tabIndex: { default: "" },
    numberRowsPerPage: {
      default: -1,
    },
  },
  data() {
    return {
      permission129: "GetAllDischargePermissionWithoutItems",
      pageSizeManual: 10,
      gridDataSource: { data: [] },
      gridSearchData: {
        dischargePermissionQueryState: "1",
      },
    };
  },
  mounted() {
    this.pageSizeManual = this.numberRowsPerPage ? this.numberRowsPerPage : -1;
    this.gridDataSource = {
      type: "app",
      service: "Inventory/api/DischargePermissionQuery",
    };
    this.renderGrid();
    this.listenToDischargeEvents();
  },
  methods: {
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 200);
    },
    listenToDischargeEvents() {
      window.addEventListener("notification-event", (event) => {
        Swal.fire({
          position: "center-center",
          type: "error",
          text: event.detail.message,
          showConfirmButton: false,
          showCloseButton: true,
        });
      });
    },
  },
};
</script>
